export default function Currency({ amount = 0, locale = 'en-US', currency = 'USD' }) {
  // Abbreviate large numbers
  let displayAmount = amount;
  let suffix = '';
  
  if (Math.abs(amount) >= 1e9) {
    displayAmount = amount / 1e9;
    suffix = 'B';
  } else if (Math.abs(amount) >= 1e6) {
    displayAmount = amount / 1e6;
    suffix = 'M';
  } else if (Math.abs(amount) >= 1e3) {
    displayAmount = amount / 1e3;
    suffix = 'K';
  }
  
  // Format the number with appropriate decimal places
  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: suffix ? 1 : 0,
    maximumFractionDigits: suffix ? 1 : 0
  });
  
  const formatted = formatter.format(displayAmount);
  
  // Add suffix after the formatted number
  // For USD, format is like $1.2 so we add suffix directly after the number
  return <>{suffix ? `${formatted}${suffix}` : formatted}</>;
}
